import axios from "axios";

const axiosClientNet = axios.create({
    //    baseURL: "http://localhost:7000/api",
    baseURL: import.meta.env.VITE_MIX_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withXSRFToken : import.meta.env.VITE_BACKEND_TYPE === 'php',
    withCredentials: true,
})

export default axiosClientNet;
